import {JsonProperty} from 'json-typescript-mapper';
import {MarketDateComment} from './market-date-comment.model';
import {Contact, ContactSimplified} from './contact.model';
import {MarketdateStatus} from './marketdate-status.model';

export enum MarketOperation {
  Cancelled = <any>'Cancelled',
  TakesPlace = <any>'TakesPlace',
  Before = <any>'Before',
  After = <any>'After'
};

export class MarketdateBoothStatistics {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('boothCount')
  public boothCount?: number;

  @JsonProperty('completedBooths')
  public completedBooths?: number;

  @JsonProperty('soldSqm')
  public soldSqm?: number;

  @JsonProperty('occupiedSqm')
  public occupiedSqm?: number;

  constructor() {
    this.id = void 0;
    this.boothCount = void 0;
    this.completedBooths = void 0;
    this.soldSqm = void 0;
    this.occupiedSqm = void 0;
  }
}

export class MarketOverviewEntry {

  @JsonProperty('marketdateId')
  public marketdateId?: string;

  @JsonProperty('closedAt')
  public closedAt?: string;

  @JsonProperty('closedBy')
  public closedBy?: string;

  @JsonProperty('closedByContact')
  public closedByContact?: ContactSimplified;

  @JsonProperty('deferred')
  public deferred?: boolean;

  @JsonProperty('evasiveDate')
  public evasiveDate?: string;

  @JsonProperty({clazz: MarketDateComment, name: 'marketDateComments'})
  public marketDateComments?: MarketDateComment[];

  @JsonProperty('marketTitle')
  public marketTitle?: string;

  @JsonProperty('openedAt')
  public openedAt?: string;

  @JsonProperty('openedBy')
  public openedBy?: string;

  @JsonProperty('openedByContact')
  public openedByContact?: ContactSimplified;

  @JsonProperty('originalDate')
  public originalDate?: string;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty('marketdateStatuses')
  public marketdateStatuses?: MarketdateStatus[];

  @JsonProperty('total')
  public total?: number;

  @JsonProperty('marketMasters')
  public marketMasters?: ContactSimplified[];

  @JsonProperty({clazz: Contact, name: 'interimsMarketMaster1'})
  public interimsMarketMaster1?: Contact;

  @JsonProperty({clazz: Contact, name: 'interimsMarketMaster2'})
  public interimsMarketMaster2?: Contact;

  @JsonProperty({clazz: Contact, name: 'interimsMarketMaster3'})
  public interimsMarketMaster3?: Contact;

  @JsonProperty('modifiedBy')
  public modifiedBy?: string;

  @JsonProperty('modifiedByNumber')
  public modifiedByNumber?: string;

  @JsonProperty('updatedAt')
  public updatedAt?: number;

  @JsonProperty('marketDayNumber')
  public marketDayNumber?: string;

  @JsonProperty('branch')
  public branch?: string;

  @JsonProperty('holiday')
  public holiday?: boolean;

  @JsonProperty('canceled')
  public canceled?: boolean;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('onHoliday')
  public onHoliday?: MarketOperation;

  @JsonProperty('transferred')
  public transferred?: boolean;

  @JsonProperty('transferredAt')
  public transferredAt?: string;

  @JsonProperty('openPayments')
  public openPayments?: number;

  @JsonProperty({clazz: MarketdateBoothStatistics, name: 'marketdateBoothStatistics'})
  public marketdateBoothStatistics?: MarketdateBoothStatistics;

  constructor() {
    this.marketdateId = void 0;
    this.closedAt = void 0;
    this.closedBy = void 0;
    this.closedByContact = void 0;
    this.deferred = void 0;
    this.evasiveDate = void 0;
    this.marketDateComments = void 0;
    this.marketTitle = void 0;
    this.openedAt = void 0;
    this.openedBy = void 0;
    this.openedByContact = void 0;
    this.originalDate = void 0;
    this.status = void 0;
    this.marketdateStatuses = void 0;
    this.total = void 0;
    this.marketMasters = void 0;
    this.interimsMarketMaster1 = void 0;
    this.interimsMarketMaster2 = void 0;
    this.interimsMarketMaster3 = void 0;
    this.modifiedBy = void 0;
    this.modifiedByNumber = void 0;
    this.updatedAt = void 0;
    this.marketDayNumber = void 0;
    this.branch = void 0;
    this.holiday = void 0;
    this.canceled = void 0;
    this.comment = void 0;
    this.onHoliday = void 0;
    this.transferred = void 0;
    this.transferredAt = void 0;
    this.openPayments = void 0;
    this.marketdateBoothStatistics = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/market-overview-entry.model.ts